import React from 'react';
import {
  VStack,
  Select,
  SelectTrigger,
  SelectInput,
  SelectIcon,
  SelectPortal,
  SelectBackdrop,
  SelectContent,
  SelectDragIndicatorWrapper,
  SelectDragIndicator,
  SelectItem,
  Icon,
  ChevronDownIcon,
  Button,
  ButtonText,
  HStack,
  Spinner,
} from '@gluestack-ui/themed';
import useData from '../hooks/useData';

const CourseSelector = ({ onConfirm, onCancel, isLoading = false }) => {
  const { data: courses, isLoading: isLoadingCourses } = useData({
    objectName: 'courses',
    filter: { state: 'active', isDeprecated: false },
  });

  const [selectedCourseId, setSelectedCourseId] = React.useState('');

  return (
    <VStack space="lg" mt="$4">
      {isLoadingCourses ? (
        <HStack space="sm" alignItems="center" justifyContent="center" p="$4">
          <Spinner size="small" />
        </HStack>
      ) : (
        <Select
          selectedValue={selectedCourseId}
          onValueChange={(value) => setSelectedCourseId(value)}
        >
          <SelectTrigger variant="outline" size="md">
            <SelectInput placeholder="Select course" />
            <SelectIcon mr="$3">
              <Icon as={ChevronDownIcon} />
            </SelectIcon>
          </SelectTrigger>
          <SelectPortal>
            <SelectBackdrop />
            <SelectContent>
              <SelectDragIndicatorWrapper>
                <SelectDragIndicator />
              </SelectDragIndicatorWrapper>
              <SelectItem label="None" value="" />
              {(Array.isArray(courses) ? courses : []).map((course) => (
                <SelectItem key={course.id} label={course.title} value={course.id} />
              ))}
            </SelectContent>
          </SelectPortal>
        </Select>
      )}

      <HStack space="md" justifyContent="flex-end" mt="$4">
        <Button variant="outline" action="secondary" onPress={onCancel} isDisabled={isLoading || isLoadingCourses}>
          <ButtonText>Cancel</ButtonText>
        </Button>
        <Button
          action="primary"
          onPress={() => onConfirm(selectedCourseId)}
          isDisabled={isLoading || isLoadingCourses || !selectedCourseId}
        >
          <ButtonText>Enroll Users</ButtonText>
        </Button>
      </HStack>
    </VStack>
  );
};

export default CourseSelector;
